import {
  TextField,
  InputLabel,
  MenuItem,
  Select,
  Grid,
} from "@mui/material";
import React from "react";

import CustomDropzone from "../../../../components/CustomDropzone";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";

export default class ImageProperties {
  static DisplayTab(props) {
    const { onChange, state, theme, onPropertieChange } = props;

    const label = getUnitPropertie(state, "label");
    const url = getUnitPropertie(state, "url");

    function getBase64(file) {
      const reader = new FileReader();
      try {
        reader.readAsDataURL(file[0]);
        reader.onload = function () {
          const event = { target: { name: "url", value: reader.result } };
          onPropertieChange(event);
        };
      } catch (error) {}
    }

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={onPropertieChange}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
            fullWidth
            helperText={language.toolTipLabel}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.propertieDescription}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={onPropertieChange}
            name="url"
            variant="outlined"
            value={url ? url && url.substring(0, 200) : ""}
            label={language.externalUrl}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            helperText={language.toolTipExternalUrl}
          />
        </Grid>

        <Grid item size={12}>
          <CustomDropzone
            filesLimit={1}
            maxSize={700000}
            onAdd={(files) => getBase64(files)}
          />
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const { onPropertieChange, state, classes } = props;

    const align = getUnitPropertie(state, "align");
    const width = getUnitPropertie(state, "width");
    const height = getUnitPropertie(state, "height");
    const widthProportion = getUnitPropertie(state, "widthProportion");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <InputLabel>{language.propertieAlign}</InputLabel>
          <Select
            name="align"
            onChange={(event) => onPropertieChange(event)}
            value={align || ""}
            fullWidth
            variant="outlined"
          >
            <MenuItem value="left">{language.left}</MenuItem>
            <MenuItem value="center">{language.center}</MenuItem>
            <MenuItem value="right">{language.right}</MenuItem>
          </Select>
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="width"
            variant="outlined"
            id="width"
            label={language.propertieWidth}
            value={width || ""}
            type="number"
            fullWidth
            helperText={language.toolTipWidth}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="height"
            variant="outlined"
            id="height"
            label={language.propertieHeight}
            value={height || ""}
            type="number"
            fullWidth
            helperText={language.toolTipHeight}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="widthProportion"
            variant="outlined"
            id="widthProportion"
            label={language.propertieWidthProportion}
            value={widthProportion || ""}
            type="number"
            fullWidth
            helperText={language.toolTipWidthProportion}
          />
        </Grid>
      </Grid>
    );
  }

  static StylesTab(props) {
    const { onPropertieChange, state } = props;
    const propertieCSS = getUnitPropertie(state, "propertieCSS");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="propertieCSS"
            variant="outlined"
            id="standard-basic"
            label={language.propertieCSS}
            value={propertieCSS || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipCSS}
          />
        </Grid>
      </Grid>
    );
  }
}
